import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../css_files/Master/AddSubCategoryMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import getCookie from "../../api";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";
import { triggerscroll } from "../Homepage/Homepage";
import Select from "react-select";

function AddSubCategoryMaster({
  setshowaddform,
  reload,
  setReload,
  triggerupdate,
  servicemasterupdatedata,
}) {
  const [ServiceMasterData, setServiceMasterData] = useState({
    Name: triggerupdate ? servicemasterupdatedata?.name : "",
    ServiceReportMasterSubCategories: triggerupdate
      ? servicemasterupdatedata?.serviceReportMasterSubCategories?.map((x) => ({
          ...x,
          Name: x.name,
        }))
      : [
          {
            Name: "",
          },
        ],
  });
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState(false);
  const { setExpiredSession } = useContext(triggerscroll);

  function handleSubmit(e) {
    e.preventDefault();

    setloading(true);
    if (triggerupdate) {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/ServiceReportMaster/UpdateCategory`;
      axiosInstance
        .put(url, {
          ...ServiceMasterData,
          Id: servicemasterupdatedata.id,
        })
        .then((res) => {
          toast.success(res.data.message, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((err) => {
          if (err.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: err.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Update", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          console.log(err);
          setloading(false);
        });
    } else {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/ServiceReportMaster/CreateCategory`;
      axiosInstance
        .post(url, ServiceMasterData)
        .then((response) => {
          toast.success("Record Added Successfully", {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          console.error("Error adding hsn data:", error);
          if (error.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: "Category Already Exists",
              icon: "error",
            });
          } else {
            toast.error("Failed to Add Record", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          setloading(false);
        });
    }
  }
  return (
    <form className="add-sub-category-master" onSubmit={handleSubmit}>
      <blockquote>
        <label>
          Category Name{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="text"
          placeholder="Enter Category Name"
          value={ServiceMasterData.Name}
          onChange={(e) =>
            setServiceMasterData({
              ...ServiceMasterData,
              Name: e.target.value,
            })
          }
          required
        ></input>
      </blockquote>
      <button
        type="button"
        onClick={() => {
          setServiceMasterData({
            ...ServiceMasterData,
            ServiceReportMasterSubCategories: [
              { Name: "" },
              ...ServiceMasterData.ServiceReportMasterSubCategories,
            ],
          });
        }}
      >
        Add SubCategories
      </button>
      {ServiceMasterData.ServiceReportMasterSubCategories?.map((x, i) => (
        <blockquote>
          <label>
            Sub-Category Name{" "}
            <sup>
              <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
            </sup>
          </label>
          <aside>
            <input
              type="text"
              placeholder="Enter Sub-Category Name"
              value={
                ServiceMasterData.ServiceReportMasterSubCategories?.[i]?.Name
              }
              onChange={(e) =>
                setServiceMasterData({
                  ...ServiceMasterData,
                  ServiceReportMasterSubCategories:
                    ServiceMasterData.ServiceReportMasterSubCategories?.map(
                      (y, j) =>
                        i === j
                          ? {
                              ...y,
                              Name: e.target.value
                                .replace(/[^a-zA-Z\s]/g, "")
                                .slice(0, 100),
                            }
                          : y
                    ),
                })
              }
              required
            ></input>
            <i
              class="fa-solid fa-circle-minus"
              onClick={() => {
                if (
                  ServiceMasterData.ServiceReportMasterSubCategories?.length > 1
                ) {
                  setServiceMasterData({
                    ...ServiceMasterData,
                    ServiceReportMasterSubCategories:
                      ServiceMasterData.ServiceReportMasterSubCategories?.filter(
                        (_, j) => j != i
                      ),
                  });
                }
              }}
            ></i>
          </aside>
        </blockquote>
      ))}

      <button type="submit">{triggerupdate ? "Update" : "Add"} </button>
      <CloseForm close={setshowaddform} />
      {loading && <LoadingScreen />}
    </form>
  );
}

export default AddSubCategoryMaster;
